import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useMobileAppPlatform } from "./useIsMobileApp";

const QUERY_KEY = ["appSubmitting"];

/**
 * Global “embedded / restricted shell” flag (React Query cache).
 * Defaults to **false**. It is **not** inferred from `window.IS_MOBILE_APP` or the WebView;
 * turn it on or off only with `setIsAppSubmitting` from your own code or native bridge.
 */
export const useAppSubmitting = () => {
  const queryClient = useQueryClient();
  const platform = useMobileAppPlatform();

  const { data: cachedFlag = false } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => queryClient.getQueryData<boolean>(QUERY_KEY) ?? false,
    initialData: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  const setIsAppSubmitting = (value: boolean) => {
    queryClient.setQueryData(QUERY_KEY, value);
  };

  return {
    isAppSubmitting: platform.isMobileAppAndroid || cachedFlag,
    setIsAppSubmitting,
  };
};
